


















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class Panels extends Vue {
  @Prop()
  private readonly groups!: string[];

  @Prop({ default: 'panel-' })
  private readonly fragmentPrefix!: string;

  private selectedGroup = ''

  private mobileSelection = ''

  sanitiseFragment(frag: string, excludePrefix = false) {
    return (excludePrefix ? '' : this.fragmentPrefix) + frag.split(' ').join('-').toLowerCase();
  }

  mounted() {
    this.goto(null, this.groups[0]);
  }

  @Watch('$route.hash')
  hashUpdated() {
    console.log(this.$route.hash);

    const opt = this.$route.hash.substring(1);

    this.selectedGroup = opt;
  }

  handleMobileSelection(e: any) {
    this.goto(null, this.mobileSelection);
  }

  goto(e: any, target: string) {
    if (e) e.preventDefault();

    this.mobileSelection = target;
    this.selectedGroup = this.sanitiseFragment(target);
    window.location.hash = this.selectedGroup;
  }
}
